import { InboxOutlined } from '@ant-design/icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const InitialFileState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">{t('formFilling.dndTitle')}</p>
      <p className="ant-upload-hint">{t('formFilling.dndHint')}</p>
    </>
  );
};

export default React.memo(InitialFileState);
